exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.body[data-v-742c7fbb] {\n    height: 100vh;\n}\n\n", ""]);

// exports
